/**
 * Safe wind sectors per station, as entered by the station owner in Flumen
 * (`Green` / `Yellow` / `Red` comma-separated cardinal lists). Used by the
 * flight-safety badge, the map marker and the wind chart barbs alike.
 */
const splitList = (v) => (typeof v === 'string' ? v.split(',').map((s) => s.trim().toUpperCase()).filter(Boolean) : []);

/** `{green, yellow, red}` from a Flumen station record, or null when it has no sector data at all. */
export function parseSectors(station) {
    if (!station) return null;
    const hasAny = ['Green', 'Yellow', 'Red'].some((k) => typeof station[k] === 'string' && station[k].trim() !== '');
    if (!hasAny) return null;
    return { green: splitList(station.Green), yellow: splitList(station.Yellow), red: splitList(station.Red) };
}

/**
 * Directions considered suitable for the "Good Wind" status: Flumen Green ∪
 * Yellow when the station has sector data; otherwise the site's hardcoded
 * `suitableWindDirections` fallback; otherwise null (no information).
 */
export function suitableDirections(sectors, site) {
    if (sectors && (sectors.green.length || sectors.yellow.length)) {
        return [...new Set([...sectors.green, ...sectors.yellow])];
    }
    return Array.isArray(site?.suitableWindDirections) && site.suitableWindDirections.length ? site.suitableWindDirections : null;
}
